var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer3Winter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3001 610",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-3",
    serifId: "layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-and-car-2",
    serifId: "house and car 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2674.52,115.636c-0.935,-2.859 -3.602,-4.793 -6.611,-4.793c-3.008,-0 -5.676,1.934 -6.61,4.793c-12.461,37.209 -38.182,118.939 -38.182,159.594c0,33.301 20.071,60.336 44.792,60.336c24.721,0 44.792,-27.035 44.792,-60.336c-0,-40.655 -25.721,-122.385 -38.181,-159.594Z",
    style: {
      fill: "#146479"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2765.59,161.394c-0.817,-3.034 -3.568,-5.142 -6.71,-5.142c-3.142,-0 -5.893,2.108 -6.71,5.142c-7.715,26.825 -19.331,71.099 -19.331,94.518c-0,21.764 11.669,39.435 26.041,39.435c14.373,-0 26.042,-17.671 26.042,-39.435c0,-23.419 -11.616,-67.693 -19.332,-94.518Z",
    style: {
      fill: "#146479"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2467.35,241.791c-0.806,-2.532 -3.158,-4.252 -5.816,-4.252c-2.657,-0 -5.009,1.719 -5.815,4.252c-9.33,28.269 -26.604,84.454 -26.604,112.927c0,24.212 14.527,43.869 32.42,43.869c17.892,-0 32.419,-19.657 32.419,-43.869c-0,-28.473 -17.274,-84.658 -26.604,-112.927Z",
    style: {
      fill: "#146479"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2491.56,233.091l35.052,-77.717l101.458,78.09l-0.847,102.102l-135.584,0l-0.079,-102.475Z",
    style: {
      fill: "#ffe8a5"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2491.56,233.091l35.052,-77.717l101.458,78.09l-0.847,102.102l-135.584,0l-0.079,-102.475Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2500.37,235.289c0,-0.184 0.036,-0.366 0.107,-0.536c1.515,-3.679 18.812,-45.676 23.601,-57.303c0.21,-0.512 0.705,-0.849 1.258,-0.858c0.553,-0.01 1.058,0.311 1.286,0.815c5.218,11.547 24.184,53.521 25.904,57.327c0.082,0.182 0.125,0.38 0.125,0.58c0,5.733 0,90.881 0,102.911c0,0.778 -0.631,1.409 -1.409,1.409c-7.433,-0 -42.03,-0 -49.463,-0c-0.778,-0 -1.409,-0.631 -1.409,-1.409c0,-12.048 0,-97.428 0,-102.936Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.76
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2533.15,335.566c1.68,0 3.041,-1.361 3.041,-3.041c0,-9.382 0,-37.801 0,-47.182c0,-1.68 -1.361,-3.042 -3.041,-3.042c-3.629,0 -9.658,0 -13.286,0c-1.68,0 -3.042,1.362 -3.042,3.042c0,9.381 0,37.8 0,47.182c0,1.68 1.362,3.041 3.042,3.041c3.628,0 9.657,0 13.286,0Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2521.79,141.794c-0.749,0.003 -1.427,0.444 -1.732,1.128c-4.159,9.321 -32.953,73.849 -39.205,87.861c-0.263,0.589 -0.21,1.272 0.141,1.813c0.352,0.541 0.953,0.868 1.598,0.868c2.542,0 6.091,0 7.943,0c0.752,0 1.434,-0.442 1.74,-1.129c4.276,-9.583 34.342,-76.961 34.342,-76.961c-0,-0 28.683,64.279 34.002,76.2c0.513,1.15 1.654,1.89 2.913,1.89c10.46,0 57.622,0 73.07,0c1.08,0 2.087,-0.547 2.675,-1.453c0.588,-0.907 0.678,-2.049 0.237,-3.036c-7.423,-16.637 -33.195,-74.391 -38.203,-85.616c-0.515,-1.154 -1.663,-1.895 -2.926,-1.89c-11.544,0.049 -67.565,0.286 -76.595,0.325Z",
    style: {
      fill: "#1d5d83"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2521.79,141.794c-0.749,0.003 -1.427,0.444 -1.732,1.128c-4.159,9.321 -32.953,73.849 -39.205,87.861c-0.263,0.589 -0.21,1.272 0.141,1.813c0.352,0.541 0.953,0.868 1.598,0.868c2.542,0 6.091,0 7.943,0c0.752,0 1.434,-0.442 1.74,-1.129c4.276,-9.583 34.342,-76.961 34.342,-76.961c-0,-0 28.683,64.279 34.002,76.2c0.513,1.15 1.654,1.89 2.913,1.89c10.46,0 57.622,0 73.07,0c1.08,0 2.087,-0.547 2.675,-1.453c0.588,-0.907 0.678,-2.049 0.237,-3.036c-7.423,-16.637 -33.195,-74.391 -38.203,-85.616c-0.515,-1.154 -1.663,-1.895 -2.926,-1.89c-11.544,0.049 -67.565,0.286 -76.595,0.325Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2496.47,137.054c7.497,18.756 29.039,7.851 43.119,13.728c14.164,5.911 13.276,17.778 26.647,23.943c11.49,5.298 14.947,-7.487 24.334,-10.464c12.673,-4.019 21.904,10.931 34.667,1.074c2.268,-1.752 4.307,-3.749 6.113,-5.977c2.295,-2.832 4.2,-6.303 4.275,-10.037c0.299,-14.907 -25.068,-20.115 -35.44,-23.315c-30.859,-9.519 -82.636,-22.361 -103.715,11.048Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2554.59,99.254c1.164,2.016 3.315,3.258 5.643,3.258c2.328,-0 4.48,-1.242 5.644,-3.258c9.631,-15.944 28.211,-48.847 28.211,-65.4c-0,-18.684 -15.17,-33.854 -33.855,-33.854c-18.684,0 -33.854,15.17 -33.854,33.854c0,16.553 18.58,49.456 28.211,65.4Z",
    style: {
      fill: "#1d5d83"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2554.59,99.254c1.164,2.016 3.315,3.258 5.643,3.258c2.328,-0 4.48,-1.242 5.644,-3.258c9.631,-15.944 28.211,-48.847 28.211,-65.4c-0,-18.684 -15.17,-33.854 -33.855,-33.854c-18.684,0 -33.854,15.17 -33.854,33.854c0,16.553 18.58,49.456 28.211,65.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2545.94,28.112c-3.474,3.473 -3.474,9.105 0,12.579c3.474,3.472 9.105,3.472 12.579,-0l6.194,-6.194c0.633,-0.633 1.655,-0.633 2.288,-0c0.631,0.63 0.631,1.655 -0,2.287l-4.453,4.453c3.494,2.917 8.7,2.734 11.981,-0.546c3.474,-3.474 3.474,-9.106 -0,-12.579c-3.473,-3.474 -9.105,-3.474 -12.579,-0l-6.195,6.194c-0.63,0.631 -1.655,0.631 -2.287,0c-0.631,-0.632 -0.631,-1.655 -0,-2.287l4.453,-4.454c-3.494,-2.916 -8.7,-2.734 -11.981,0.547Zm14.295,-2.825c-4.764,-4.192 -12.031,-4.013 -16.582,0.537c-4.736,4.738 -4.736,12.417 -0,17.154c4.551,4.55 11.818,4.728 16.582,0.536c4.764,4.192 12.031,4.014 16.581,-0.536c4.736,-4.737 4.736,-12.416 0,-17.154c-4.55,-4.55 -11.817,-4.729 -16.581,-0.537Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2379.05,284.719c-4.799,14.691 -17.734,28.812 -31.443,36.047c-10.707,5.65 -21.908,7.171 -29.93,0.93c-0.736,-0.584 -1.808,-0.461 -2.392,0.275c-0.584,0.736 -0.461,1.808 0.275,2.392c8.942,7.247 21.663,6.183 33.913,0.026c14.849,-7.464 28.934,-22.399 34.391,-38.044c0.449,-1.329 -0.266,-2.771 -1.594,-3.22c-1.329,-0.449 -2.772,0.266 -3.22,1.594Z",
    style: {
      fill: "#383128"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2386.39,277.834c-0,-1.302 -0.518,-2.552 -1.439,-3.473c-0.922,-0.922 -2.171,-1.439 -3.474,-1.439c-0.002,-0 -0.004,-0 -0.006,-0c-1.302,-0 -2.552,0.517 -3.473,1.439c-0.922,0.921 -1.439,2.171 -1.439,3.473c-0,19.073 -0,87.159 -0,87.159l9.831,0l-0,-87.159Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2386.39,277.834c-0,-1.302 -0.518,-2.552 -1.439,-3.473c-0.922,-0.922 -2.171,-1.439 -3.474,-1.439c-0.002,-0 -0.004,-0 -0.006,-0c-1.302,-0 -2.552,0.517 -3.473,1.439c-0.922,0.921 -1.439,2.171 -1.439,3.473c-0,19.073 -0,87.159 -0,87.159l9.831,0l-0,-87.159Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2376.56,
    y: 263.091,
    width: 9.831,
    height: 24.577,
    style: {
      fill: "#20f58f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2160.44,334.538c7.555,-0.456 14.051,5.169 14.497,12.554c0.446,7.385 -5.326,13.751 -12.881,14.207c-7.555,0.456 -14.05,-5.169 -14.496,-12.554c-0.446,-7.384 5.325,-13.75 12.88,-14.207Z",
    style: {
      fill: "#1d5d83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2272.05,330.094c8.397,-0.507 15.618,5.745 16.113,13.953c0.496,8.209 -5.919,15.285 -14.316,15.792c-8.398,0.507 -15.618,-5.745 -16.114,-13.954c-0.496,-8.208 5.92,-15.284 14.317,-15.791Z",
    style: {
      fill: "#1d5d83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2331.67,346.85c0.077,1.784 -0.568,3.523 -1.791,4.825c-1.222,1.301 -2.918,2.054 -4.703,2.088c-29.715,0.571 -147.487,2.832 -161.864,3.108c-0.959,0.018 -1.918,-0.043 -2.866,-0.183c-2.655,-0.392 -8.583,-1.266 -14.028,-2.069c-6.227,-0.919 -10.569,-6.659 -9.757,-12.901c-0,-0.001 0,-0.003 0,-0.004c1.073,-8.254 7.095,-15.006 15.173,-17.012l37.494,-9.31c0.683,-0.17 1.334,-0.447 1.929,-0.821c2.184,-1.373 8.065,-5.068 14.467,-9.091c14.249,-8.954 30.582,-14.047 47.394,-14.78c0,-0 0,-0 0.001,-0c15.954,-0.695 31.832,2.57 46.217,9.506c10.217,4.927 21.363,10.301 27.087,13.061c2.385,1.15 3.944,3.517 4.059,6.163c0.288,6.652 0.845,19.504 1.188,27.42Z",
    style: {
      fill: "#ffe8a5"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2331.67,346.85c0.077,1.784 -0.568,3.523 -1.791,4.825c-1.222,1.301 -2.918,2.054 -4.703,2.088c-29.715,0.571 -147.487,2.832 -161.864,3.108c-0.959,0.018 -1.918,-0.043 -2.866,-0.183c-2.655,-0.392 -8.583,-1.266 -14.028,-2.069c-6.227,-0.919 -10.569,-6.659 -9.757,-12.901c-0,-0.001 0,-0.003 0,-0.004c1.073,-8.254 7.095,-15.006 15.173,-17.012l37.494,-9.31c0.683,-0.17 1.334,-0.447 1.929,-0.821c2.184,-1.373 8.065,-5.068 14.467,-9.091c14.249,-8.954 30.582,-14.047 47.394,-14.78c0,-0 0,-0 0.001,-0c15.954,-0.695 31.832,2.57 46.217,9.506c10.217,4.927 21.363,10.301 27.087,13.061c2.385,1.15 3.944,3.517 4.059,6.163c0.288,6.652 0.845,19.504 1.188,27.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2300.05,331.036c10.205,2.359 16.617,12.374 14.311,22.349c-2.307,9.975 -12.465,16.157 -22.67,13.797c-10.204,-2.36 -16.617,-12.374 -14.31,-22.349c2.307,-9.975 12.465,-16.157 22.669,-13.797Z",
    style: {
      fill: "#ffcf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2198.34,331.554c10.205,2.36 16.617,12.374 14.31,22.349c-2.307,9.975 -12.464,16.158 -22.669,13.798c-10.205,-2.36 -16.617,-12.374 -14.31,-22.349c2.307,-9.975 12.464,-16.158 22.669,-13.798Z",
    style: {
      fill: "#ffcf6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140.39,340.586c-0.464,1.633 -0.222,3.386 0.668,4.832c0.89,1.447 2.346,2.453 4.013,2.776c4.279,0.827 9.714,1.878 13.174,2.547c2.069,0.4 4.173,-0.494 5.322,-2.259c2.048,-3.148 5.334,-8.199 7.717,-11.86c1.927,-2.962 4.597,-5.368 7.743,-6.978c5.006,-2.561 12.775,-6.536 17.554,-8.981c0.471,-0.241 0.716,-0.774 0.593,-1.289c-0.124,-0.514 -0.584,-0.877 -1.114,-0.878c-3.896,-0.004 -8.986,-0.01 -10.348,-0.011c-0.231,-0.001 -0.46,0.027 -0.684,0.083c-2.481,0.616 -18.129,4.5 -29.43,7.306c-7.34,1.822 -13.142,7.435 -15.208,14.71c-0,0.001 -0,0.001 -0,0.002Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.87
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2220.86,317.332c-0.169,0.009 -0.327,-0.08 -0.409,-0.228c-0.081,-0.147 -0.07,-0.329 0.027,-0.466c0.49,-0.688 1.292,-1.816 2.287,-3.214c8.907,-12.521 23.68,-19.513 39.009,-18.465c0.001,-0 0.002,-0 0.003,-0c8.399,0.574 16.632,2.619 24.323,6.042c5.298,2.357 11.488,5.111 16.496,7.34c1.051,0.467 1.644,1.594 1.434,2.725c-0.209,1.13 -1.167,1.97 -2.315,2.03c-22.288,1.168 -73.419,3.846 -80.855,4.236Z",
    style: {
      fill: "#1d5d83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2224.79,300.954c0.182,-0.216 0.198,-0.526 0.041,-0.76c-0.158,-0.234 -0.452,-0.335 -0.72,-0.247c-9.967,3.337 -20.086,8.794 -26.743,14.804c-0.185,0.173 -0.249,0.44 -0.162,0.678c0.088,0.238 0.309,0.401 0.562,0.413c3.473,0.165 11.936,0.567 13.668,0.649c0.197,0.009 0.387,-0.074 0.513,-0.225c1.383,-1.649 9.527,-11.361 12.841,-15.312Z",
    style: {
      fill: "#1d5d83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2193.26,334.755c8.398,-0.507 15.618,5.745 16.114,13.954c0.495,8.208 -5.92,15.284 -14.317,15.791c-8.398,0.507 -15.618,-5.745 -16.114,-13.953c-0.495,-8.209 5.92,-15.285 14.317,-15.792Z",
    style: {
      fill: "#1d5d83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2294.97,334.236c8.397,-0.507 15.617,5.746 16.113,13.954c0.496,8.208 -5.919,15.284 -14.317,15.792c-8.397,0.507 -15.618,-5.746 -16.113,-13.954c-0.496,-8.208 5.919,-15.284 14.317,-15.792Z",
    style: {
      fill: "#1d5d83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2716.14,67.917c-0.09,-2.045 -1.73,-3.681 -3.775,-3.768c-2.046,-0.087 -3.818,1.405 -4.081,3.435c-6.891,49.437 -17.496,131.441 -17.496,168.129c-0,33.741 6.262,59.634 15.815,59.634c9.553,-0 15.815,-24.393 15.815,-58.134c0,-36.698 -3.805,-119.419 -6.278,-169.296Z",
    style: {
      fill: "#146479"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "trees-3",
    serifId: "trees 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1081,224.415c-0.584,-2.147 -2.533,-3.637 -4.758,-3.638c-2.225,0 -4.174,1.491 -4.758,3.638c-9.435,34.058 -29.617,111.37 -29.617,149.613c0,30.98 15.403,56.132 34.375,56.132c18.973,-0 34.375,-25.152 34.375,-56.132c0,-38.243 -20.181,-115.555 -29.617,-149.613Z",
    style: {
      fill: "#1d5d83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "trees-2",
    serifId: "trees 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1177.51,346.553c17.876,0.994 15.11,-31.313 -6.296,-33.866c-13.725,-1.636 -12.839,6.327 -21.127,6.29c-10.626,-0.047 -5.515,-18.714 -26.401,-19.271c-23.788,-0.634 -31.293,29.495 -21.831,40.373c5.128,5.894 8.635,14.037 15.474,14.629c8.214,0.711 16.454,1.113 24.653,1.987c13.422,1.429 13.861,-11.347 35.528,-10.142Z",
    style: {
      fill: "#1d5d83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M995.665,343.492c0,-1.993 -1.616,-3.608 -3.609,-3.608c-7.868,-0 -26.65,-0 -36.512,-0c-1.3,-0 -2.5,-0.699 -3.141,-1.829c-0.641,-1.131 -0.624,-2.519 0.044,-3.635c8.498,-14.134 17.814,-26.748 28.767,-36.332c1.164,-0.964 1.598,-2.553 1.086,-3.974c-0.512,-1.421 -1.86,-2.369 -3.37,-2.369c-5.331,-0.026 -11.562,-0.026 -15.802,-0.026c-1.168,0 -2.263,-0.564 -2.94,-1.515c-0.678,-0.95 -0.854,-2.17 -0.472,-3.273c4.948,-14.067 12.016,-26.9 23.691,-37.055c1.139,-0.962 1.555,-2.534 1.043,-3.934c-0.513,-1.4 -1.845,-2.331 -3.336,-2.331c-1.687,-0.057 -3.381,-0.057 -4.92,-0.057c-1.293,0 -2.487,-0.691 -3.131,-1.813c-0.643,-1.122 -0.637,-2.503 0.016,-3.619c9.089,-15.447 19.284,-28.542 31.207,-37.981c1.319,-1.025 3.169,-1.009 4.47,0.038c13.316,10.811 22.487,23.79 28.48,38.433c0.442,1.108 0.306,2.363 -0.363,3.351c-0.67,0.988 -1.785,1.579 -2.978,1.579c-1.922,0.012 -4.172,0.012 -6.384,0.012c-1.503,0.001 -2.848,0.933 -3.376,2.34c-0.529,1.407 -0.13,2.994 1,3.984c11.829,10.489 19.602,23.039 24.361,37.11c0.36,1.095 0.172,2.297 -0.504,3.231c-0.676,0.933 -1.759,1.486 -2.912,1.486c-4.075,0.014 -10.037,0.014 -15.263,0.014c-1.537,0 -2.905,0.974 -3.408,2.426c-0.504,1.451 -0.033,3.063 1.172,4.015c13.31,10.586 22.428,23.018 28.949,36.585c0.523,1.115 0.44,2.42 -0.22,3.459c-0.66,1.039 -1.806,1.669 -3.037,1.669c-9.251,0.011 -27.505,0.011 -35.248,0.011c-0.957,-0 -1.875,0.38 -2.552,1.057c-0.677,0.676 -1.057,1.594 -1.057,2.551c0,11.191 0,44.556 0,44.556l-19.751,0l0,-44.556Z",
    style: {
      fill: "#1d5d83"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M995.665,343.492c0,-1.993 -1.616,-3.608 -3.609,-3.608c-7.868,-0 -26.65,-0 -36.512,-0c-1.3,-0 -2.5,-0.699 -3.141,-1.829c-0.641,-1.131 -0.624,-2.519 0.044,-3.635c8.498,-14.134 17.814,-26.748 28.767,-36.332c1.164,-0.964 1.598,-2.553 1.086,-3.974c-0.512,-1.421 -1.86,-2.369 -3.37,-2.369c-5.331,-0.026 -11.562,-0.026 -15.802,-0.026c-1.168,0 -2.263,-0.564 -2.94,-1.515c-0.678,-0.95 -0.854,-2.17 -0.472,-3.273c4.948,-14.067 12.016,-26.9 23.691,-37.055c1.139,-0.962 1.555,-2.534 1.043,-3.934c-0.513,-1.4 -1.845,-2.331 -3.336,-2.331c-1.687,-0.057 -3.381,-0.057 -4.92,-0.057c-1.293,0 -2.487,-0.691 -3.131,-1.813c-0.643,-1.122 -0.637,-2.503 0.016,-3.619c9.089,-15.447 19.284,-28.542 31.207,-37.981c1.319,-1.025 3.169,-1.009 4.47,0.038c13.316,10.811 22.487,23.79 28.48,38.433c0.442,1.108 0.306,2.363 -0.363,3.351c-0.67,0.988 -1.785,1.579 -2.978,1.579c-1.922,0.012 -4.172,0.012 -6.384,0.012c-1.503,0.001 -2.848,0.933 -3.376,2.34c-0.529,1.407 -0.13,2.994 1,3.984c11.829,10.489 19.602,23.039 24.361,37.11c0.36,1.095 0.172,2.297 -0.504,3.231c-0.676,0.933 -1.759,1.486 -2.912,1.486c-4.075,0.014 -10.037,0.014 -15.263,0.014c-1.537,0 -2.905,0.974 -3.408,2.426c-0.504,1.451 -0.033,3.063 1.172,4.015c13.31,10.586 22.428,23.018 28.949,36.585c0.523,1.115 0.44,2.42 -0.22,3.459c-0.66,1.039 -1.806,1.669 -3.037,1.669c-9.251,0.011 -27.505,0.011 -35.248,0.011c-0.957,-0 -1.875,0.38 -2.552,1.057c-0.677,0.676 -1.057,1.594 -1.057,2.551c0,11.191 0,44.556 0,44.556l-19.751,0l0,-44.556Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.018,231.669c3.248,-2.251 6.804,-3.809 10.314,-5.585c5.251,-2.656 10.915,-5.846 16.991,-5.637c6.769,0.233 12.718,4.683 19.66,3.296c5.389,-1.076 9.544,-4.775 14.254,-7.326c4.038,-2.187 8.64,-3.251 13.222,-3.216c2.256,-7.475 0.104,-16.019 -7.879,-19.856c-4.916,-2.364 -10.831,-2.463 -16.133,-1.601c-17.78,2.888 -31.571,19.644 -40.409,33.689",
    style: {
      fill: "#fff",
      fillOpacity: 0.75
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "mountains-2",
    serifId: "mountains 2",
    d: "M0.002,397.791c443.073,100.529 661.659,62.644 1089.48,-47.446c443.68,-114.17 819.116,31.642 1221.99,5.652c328.264,-21.176 377.228,-117.833 688.527,-132.16l0,385.604l-3000,0.103l0.002,-211.753Z",
    style: {
      fill: "url(#_Linear7)"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mountains-21",
    serifId: "mountains 2",
    d: "M0.002,397.791c443.073,100.529 661.659,62.644 1089.48,-47.446c443.68,-114.17 819.116,31.642 1221.99,5.652c328.264,-21.176 377.228,-117.833 688.527,-132.16l0,385.604l-3000,0.103l0.002,-211.753Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2505.83,331.705c-37.104,12.49 -82.722,14.526 -41.775,43.471c11.208,7.923 32.427,20.26 -2.782,31.508c-81.763,26.121 -128.772,31.87 -138.258,41.811c-14.141,14.818 51.43,21.981 28.273,63.759c-14.462,26.092 -164.145,42.11 -251.569,44.007c15.652,-6.605 34.05,-18.968 34.05,-18.968c60.909,-6.719 180.965,-10.909 186.999,-31.732c9.252,-31.926 -52.806,-56.962 -18.856,-73.253c50.998,-24.471 188.851,-23.806 138.826,-59.605c-28.2,-20.181 -18.369,-29.924 53.264,-40.909l11.828,-0.089Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.64,336.223c83.611,-20.518 138.607,11.475 183.382,11.553c65.853,0.114 129.112,-26.045 188.179,-52.567c-10.283,-18.857 -40.018,-23.925 -58.754,-28.309c-59.426,-13.903 -123.208,-14.025 -183.914,-17.469c-167.782,-9.52 -362.868,-22.356 -528.444,6.452c-57.073,9.929 -115.207,23.834 -162.99,55.464c22.279,9.835 39.122,24.316 59.207,37.459c27.698,18.125 63.98,31.489 97.271,33.095c22.219,1.072 44.063,-2.439 64.796,-10.452c28.812,-11.135 54.691,-27.327 86.979,-25.524c46.912,2.621 85.851,34.65 133.586,33.598c44.083,-0.971 78.881,-33.038 120.702,-43.3Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2603.8,300.393c44.501,-23.136 101.123,-21.059 149.076,-11.754c20.347,3.948 39.889,15.271 61.101,13.734c37.987,-2.751 63.088,-39.304 100.833,-42.87c28.224,-2.667 52.676,19.883 80.816,14.955c16.246,-2.845 30.764,-14.018 24.956,-31.911c-1.65,-5.083 -3.671,-10.053 -6.159,-14.786c-3.476,-6.614 -7.887,-12.774 -13.362,-17.884c-25.992,-24.259 -67.249,-28.446 -100.955,-27.335c-38.341,1.263 -76.007,10.414 -113.059,19.637c-69.026,17.183 -139.981,41.437 -200.543,79.71",
    style: {
      fill: "#fff",
      fillOpacity: 0.79
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.841,463.055,10.8612,-0.324647,1727.9,321.266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1d5d83",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6bc3ad",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer3Winter);
export default __webpack_public_path__ + "static/media/layer3-winter.32fa28486394c160eabb93b51f5102fe.svg";
export { ForwardRef as ReactComponent };